import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
export function wrapAsyncFn(asyncFunc, config) {
    return _wrapAsyncFn.apply(this, arguments);
}
function _wrapAsyncFn() {
    _wrapAsyncFn = _async_to_generator(function(asyncFunc, config) {
        var before, after;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    before = config.before, after = config.after;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    before === null || before === void 0 ? void 0 : before();
                    return [
                        4,
                        asyncFunc()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    after === null || after === void 0 ? void 0 : after();
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _wrapAsyncFn.apply(this, arguments);
}
